import { filter, remplazarPorTildeASinTilde } from "../../helpers/Buscador";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const getCategoriasFormularios = (textoBuscado = "") => async (dispatch) => {
  dispatch({ type: types.get_categorias_formularios })
  try {
    const response = await fetchConToken(`MiOspedyc/CategoriaFormulario`);
    const body = await response.json();
    let resultados = body;
    if (response.ok) {
      if (textoBuscado !== "") {
        resultados = resultados.filter(n => filter(remplazarPorTildeASinTilde(n.descripcion), remplazarPorTildeASinTilde(textoBuscado)))
      }
      dispatch({
        type: types.get_categorias_formularios_success,
        payload: resultados
      });
    } else {
      throw body
    }
  } catch (error) {
    handleErrorApi(dispatch, error, "Error al cargar las categorias de formulario", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const guardarCategoriaFormulario = (id, data, handleAfter) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    let response;
    if (id) {
      response = await fetchConToken(
        `MiOspedyc/CategoriaFormulario/${id}`,
        data,
        "PUT"
      );
    } else {
      response = await fetchConToken(
        `MiOspedyc/CategoriaFormulario`,
        data,
        "POST"
      );
    }

    const body = await response.json();

    if (response.ok) {
      dispatch(startAlerta("Categoria guardada correctamente", 'success', 'Comando Exitoso'))
      dispatch(finishSpinner());
      handleAfter()
      dispatch(getCategoriasFormularios());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al guardar la categoria", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const eliminarCategoriaFormulario = (id) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    let response = await fetchConToken(
      `MiOspedyc/CategoriaFormulario/${id}`,
      {},
      "DELETE"
    );

    const body = await response.json();

    if (response.ok) {
      dispatch(startAlerta("Categoria eliminada correctamente", 'success', 'Comando Exitoso'))
      dispatch(finishSpinner());
      dispatch(getCategoriasFormularios());
    } else {
      throw body
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(dispatch, error, "Error al eliminar la categoria", "Ha ocurrido un error. Intente nuevamente")
  }
}

export const buscarCategoria = (text) => (dispatch) => {
  dispatch({
    type: types.abmBuscarCategoria,
    payload: text
  });
}